<script>
import PointOfInterestForm from '@views/pointOfInterests/form';

export default {
  components: {
    PointOfInterestForm,
  },
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      this.showModal = !!val;
    },
  },
  methods: {
    submit() {
      this.$emit('submitted');
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    size="lg"
    hide-footer
    :title="loadedId ? $t('titles.edit_poi') : $t('titles.create_poi')"
    static
    @hidden="$emit('hidden')"
  >
    <PointOfInterestForm
      v-if="showModal"
      :loaded-id="loadedId"
      @submitted="submit"
    />
  </b-modal>
</template>
